module.exports = __webpack_public_path__ + "static/img/Nguyenduchiet.1162122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nguyenduchiet.png
// module id = vVuz
// module chunks = 1